var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 78,
    rx: 39,
    fill: "#FAEBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.4204 23.3445C37.5829 21.3867 40.4171 21.3867 41.5796 23.3445L55.3094 46.4684C56.4967 48.4682 55.0555 51 52.7298 51H25.2702C22.9445 51 21.5033 48.4682 22.6906 46.4684L36.4204 23.3445Z",
    fill: "#D03C3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4219 31.9082H37.5775L37.8331 41.0744H40.1726L40.4219 31.9082ZM39.0029 45.1653C39.8211 45.1653 40.5306 44.4814 40.537 43.6312C40.5306 42.7939 39.8211 42.1099 39.0029 42.1099C38.1591 42.1099 37.4624 42.7939 37.4688 43.6312C37.4624 44.4814 38.1591 45.1653 39.0029 45.1653Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTest);
export default __webpack_public_path__ + "static/media/test.fae0ff0206c5415a36825096a2f54b37.svg";
export { ForwardRef as ReactComponent };